export default {
  namespaced: true,
  state: {
    creatorManagementUrl: `/api/creator/management`,
    creatorList: [],
    creatorUserList: [],
    creatorAdvertiserList: [],
  },
  getters: {
    creatorList: (state) => state.creatorList,
    creatorUserList: (state) => state.creatorUserList,
    creatorAdvertiserList: (state) => state.creatorAdvertiserList,
  },
  mutations: {
    setCreatorList: (state, data) => {
      state.creatorList = data;
    },
    initCreatorUserList: (state) => {
      state.creatorUserList = [];
    },
    setCreatorUserList: (state, data) => {
      state.creatorUserList = data;
    },
    initCreatorAdvertiserList: (state, data) => {
      state.creatorAdvertiserList = [];
    },
    setCreatorAdvertiserList: (state, data) => {
      state.creatorAdvertiserList = data;
    },
  },
  actions: {
    async getAllCreator({ commit, state }) {
      try {
        let res = await axios.get(`${state.creatorManagementUrl}/all`);
        commit("setCreatorList", res.data.creators);
        console.log(res);
      } catch (e) {
        throw e;
      }
    },
    async editCreator({ commit, state }, data) {
      try {
        const {
          creator_id,
          timezone,
          level,
          name,
          available_date,
          status,
        } = data;
        let res = await axios.put(
          `${state.creatorManagementUrl}/creator/${creator_id}`,
          { name, level, timezone, available_date, status }
        );
        console.log(res);
      } catch (e) {
        throw e;
      }
    },
    async createNewCreator({ commit, state }, data) {
      try {
        const { email, name, level, available_date, timezone, status } = data;
        let res = await axios.post(`${state.creatorManagementUrl}/creator/`, {
          email,
          name,
          level,
          available_date,
          timezone,
          status,
        });

        console.log(res);
      } catch (e) {
        throw e;
      }
    },
    async getUsersByCreatorId({ commit, state }, { creator_id }) {
      try {
        commit("initCreatorUserList");
        let res = await axios.get(
          `${state.creatorManagementUrl}/${creator_id}/users`
        );
        commit("setCreatorUserList", res.data.user_list);
      } catch (e) {
        throw e;
      }
    },
    async getAdvertisersByCreatorId({ commit, state }, { creator_id }) {
      try {
        commit("initCreatorAdvertiserList");
        let res = await axios.get(
          `${state.creatorManagementUrl}/advertisers/${creator_id}`
        );
        commit("setCreatorAdvertiserList", res.data);
        console.log(res);
        return res.data;
      } catch (e) {
        throw e;
      }
    },
    async useAdminEditUser({ commit, state }, { creator_id, data }) {
      try {
        console.log(creator_id);
        console.log(data);
        let res = await axios.put(
          `${state.creatorManagementUrl}/${creator_id}/user/edit`,
          data
        );
        console.log(res);
      } catch (e) {
        throw e;
      }
    },
    async useAdminCreateUser({ commit, state }, { creator_id, data }) {
      try {
        let res = await axios.post(
          `${state.creatorManagementUrl}/${creator_id}/user/create`,
          data
        );
      } catch (e) {
        throw e;
      }
    },
    async useAdminResendInvite({ commit, state }, { creator_id, data }) {
      try {
        let res = await axios.post(
          `${state.creatorManagementUrl}/${creator_id}/user/resend_invite`,
          data
        );
      } catch (e) {
        throw e;
      }
    },
  },
};
